import { render, staticRenderFns } from "./WidgetSideNav.vue?vue&type=template&id=7fd0ff89&"
import script from "./WidgetSideNav.vue?vue&type=script&lang=js&"
export * from "./WidgetSideNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports